import { Component } from 'react'
import { Row, Col, Card, Spin, Tooltip, Select, Tag } from 'antd'
import { ClapsImage, StarImage, MoneyImage } from '../../assets/images'
import Highstock from 'highcharts/highstock'
import ReactHighcharts from 'react-highcharts'
import { withDsChartTheme } from './../../utils/chartTheme';
import { PngExportFrame } from '../opdClaims/primitives';
import { Breadcrumb } from '../common/atoms'
import { handleAppError } from '../handlers'
import ContractsManager from '../../managers/ContractsManager'
import { analyticsApi, utilizationApi } from '../../services'
import axios from 'axios'
import { PeriodPicker } from '../common/molecules'
const Charts = withDsChartTheme(ReactHighcharts.withHighcharts(Highstock));
const { Option } = Select
let token = ''

class Challenges extends Component {
  constructor(props) {
      super(props)
      this.state = {
        loading: false,
        data: {},
        contractId: null,
        tabLoading : false,
        dropdownValue: '',
        employeeCountOverall: {filters:[], config: {}},
        baseConfig : {
          filters: [],
          config: {
            chart: {},
            title: {text: '', align: 'left'},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {},
            credits: {
              enabled: false
            },
            series: []
          }
        }
      }
  }

  componentDidMount () {
    this.fetchContractDetails()        
    this.setState({ loading: true })
  }
 
  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'Challenges')
        const contract = contractObj.formattedData[0]
        const isRunningContract = contract.is_running_contract
        this.setState({ metricObj :  contractObj, isRunningContract, contractId : contract.contract_id, startDate: contract.start_date, endDate: contract.end_date })
      },
      (err) => {
        handleAppError(err)
      }
    )
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source()
    analyticsApi.getChallengesAnalytics({contractId, startDate, endDate, cancelToken: token.token}, 
      (resp)=>{
        const fetchData = resp.data
        const dropdownValue = this.state.isRunningContract ? 'last_30days' : 'contract_period'
        this.setState({ data: fetchData, dropdownValue, loading: false, tabLoading : false })
      },
      (err)=>{
        handleAppError(err)
        this.setState({ loading: false,tabLoading : false })
      })
  }

  componentWillUnmount() {
    token && token.cancel()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel()
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate)
    }
  }
  
  changeContractId = (contract) => {
    const { contractId }  = this.state
    const { contract_id, is_running_contract, start_date, end_date } = contract
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        isRunningContract: is_running_contract,
        tabLoading: true,
      })
    } else if (contract.text === 'Overall') {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        isRunningContract: false,
        tabLoading: false,
      })
    }
  }

  handleChange(e) {
    let that = this
    that.setState({ dropdownValue: e })
  }

  renderChartTrends() {
    let that = this
    let a = that.state.dropdownValue
    const data = that.state.data[a] ?? {}
    if(a === "last_30days"){
      return(
        <div>
          {this.renderDaysChart(data)}
        </div>
      )
    }else{
      return(
        <div>
          {this.renderChart(data)}
        </div>
      )
    }    
  }

  renderChart(record) {
    let that = this
    let keys = Object.keys(record)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let series = Object.values(record)
    baseConfig.config.chart.type = 'line'
    baseConfig.config.yAxis.title = {text: "Health Challenges Count"}
    baseConfig.config.yAxis.allowDecimals = false
    baseConfig.config.xAxis = {categories: keys
                              } 
    baseConfig.config.tooltip = { pointFormat: '<span>Health Challenges Count</span>: <span class="font-semibold text-sm">{point.y}</span>',
                                  style: {color: '#FFFFFF'},
                                  backgroundColor: '#475569',
                                  borderColor: 'none'}                             
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false 
            }
        }}}
     
    baseConfig.config.series = [{name: 'Health Challenges Count',data: series.map(Number),color: '#2563EB',color1: '#ffffff'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/>
      </div>
    )
  }

  renderDaysChart(record) {
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart.type = 'line'
    baseConfig.config.xAxis = {type: 'datetime',
                              dateTimeLabelFormats: {
                                  month: '%d. %b',
                                  year: '%b'
                                }
                              } 
    baseConfig.config.yAxis.title = {text: "Health Challenges Count"}
    baseConfig.config.tooltip = { pointFormat: '<span>Health Challenges Count</span>: <span class="font-semibold text-sm">{point.y}</span>',
                                  style: {color: '#FFFFFF'},
                                  backgroundColor: '#475569',
                                  borderColor: 'none'}                             
    baseConfig.config.yAxis.allowDecimals = false                      
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false 
            }
        }}}
    baseConfig.config.series = [{name: 'Health Challenges Count',data: record,color: '#2563EB'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/>
      </div>
    )
  }

  getColor(value) {
    let color = '#E5E7EB'
    if (value === 'Obesity') {
      color = '#C4B5FD'
    }else if(value === 'Diabetes'){
      color = '#4FAD96'
    }else if(value === 'Blood Pressure'){
      color = '#FBCE7A'
    }else if(value === 'Cholestrol'){
      color = '#BFDBFE'
    }else if(value === 'Others'){
      color = '#BFDBFE'
    }
    return color
  }

  renderPopoverContent(percentage, text, color, subtext) {
    return(
      <div>
        <Row type="flex" justify="start">
          <h5 style={{color: '#9CA3AF'}}>{subtext}</h5>
        </Row>
        <Row type="flex" justify="start" style={{marginLeft: '-5px'}}>
          <h5 style={{color: '#9CA3AF'}}>&nbsp; {text} <span className="semibold" style={{color: '#ffffff'}}>{percentage}</span></h5>
        </Row>
      </div>
    )
  }

  renderDonutChart() {
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart = { type: 'pie',
                                margin: [0,0,0,0],
                                width: 200,
                                height: 225
                              }    

    baseConfig.config.tooltip = { 
                                  style: {color: '#9CA3AF'},
                                  pointFormat: '<span style="color:{point.color}">{point.percentage:.1f}%</span>',
                                  backgroundColor: '#475569',
                                  borderColor: 'none'}
    baseConfig.config.plotOptions = {
      pie: {
        allowPointSelect: true,
            cursor: 'pointer',
            colors: ['#60A5FA','#4FAD96','#FBCE7A','#BFDBFE'],
            dataLabels: {
                enabled: false
            }
      }
    }
    baseConfig.config.series = [{ name: 'h',
                                  data: that.state.data.series,
                                  size: '100%',
                                  innerSize: '60%'}]
    return(
      <PngExportFrame fileName='challenges-overview'>
        <Row type="flex" justify="start">
          <Charts disableDownload
            config={baseConfig.config}/>
        </Row>
        <Row>
            <Col span={20}>
              <Col sm={5}>
                <Row type="flex" justify="start">
                  <svg height="9" width="9">
                    <rect x="0" y="0" width="9" height="9" rx="6" ry="6" style={{fill: '#60A5FA'}}/>
                  </svg>  
                  <h6 className="web-login-track mt-minus-12">Activity</h6>
                </Row>
                <Row type="flex" justify="start">
                  <h2 className="number-style">{that.state.data.activity}</h2>
                </Row>
              </Col>
              <Col sm={5}>
                <Row type="flex" justify="start">
                  <svg height="9" width="9">
                    <rect x="0" y="0" width="9" height="9" rx="6" ry="6" style={{fill: '#4FAD96'}}/>
                  </svg>  
                  <h6 className="web-login-track mt-minus-12">Food</h6>
                </Row>
                <Row type="flex" justify="start">
                  <h2 className="number-style">{that.state.data.food}</h2>
                </Row>
              </Col>
              <Col sm={5}>
                <Row type="flex" justify="start">
                  <svg height="9" width="9">
                    <rect x="0" y="0" width="9" height="9" rx="6" ry="6" style={{fill: '#FBCE7A'}}/>
                  </svg>  
                  <h6 className="web-login-track mt-minus-12">Mind</h6>
                </Row>
                <Row type="flex" justify="start">
                  <h2 className="number-style">{that.state.data.mind}</h2>
                </Row>
              </Col>
              <Col sm={5}>
                <Row type="flex" justify="start">
                  <svg height="9" width="9">
                    <rect x="0" y="0" width="9" height="9" rx="6" ry="6" style={{fill: '#BFDBFE'}}/>
                  </svg>  
                  <h6 className="web-login-track mt-minus-12">Others</h6>
                </Row>
                <Row type="flex" justify="start">
                  <h2 className="number-style">{that.state.data.other_category}</h2>
                </Row>
              </Col>
            </Col>
          </Row>
      </PngExportFrame>
    )
  }

  getTheText = (id, data) => {
    let tab = data.find(item => item.contract_id === id)
    return tab.text  
  }

  render() {
    let that = this
    const { metricObj, isRunningContract, dropdownValue } = that.state
    const formattedData = metricObj ? metricObj.formattedData : null
    const totalPointsEarned = parseInt(that.state.data.total_points_earned)

    return(
      <div>
        {(that.state.loading || Object.keys(that.state.data).length === 0 ) ?
          <div className="spiner">
            <Spin size="large"/>
          </div>
        :
          <div>
            <Row>
              <Row>
                {/* Title block left, period control right, so the filter sits with the page identity
                    rather than below it where it read as the first row of content. */}
                <div className='flex w-full flex-wrap items-start justify-between gap-ds-4'>
                  <div className='flex min-w-0 flex-col'>
                    <Breadcrumb
                      list={[
                        { text: 'Analytics', link: '#' },
                        { text: 'Challenges', link: '/challenges' },
                      ]}
                    />
                    <h2 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0 mt-1.5'>Challenges</h2>
                    <p className='text-gray-500 leading-4 text-sm mt-2 mb-0'>Detailed analysis on challenges taken</p>
                  </div>
                  <PeriodPicker
                    list={formattedData}
                    loading={true}
                    classes='shrink-0'
                    currentPage={this.getTheText(this.state.contractId, formattedData)}
                    setContract={this.changeContractId}
                  />
                </div>
              </Row>
            </Row>
            { that.state.tabLoading ?
                <div className="spiner">
                  <Spin size="large"/>
                </div> 
              :
                <div>
                  <Row>
                    <Col span={12}>
                      <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 15}}>
                        <h4 className="sub-heading-title font-semibold" style={{color: '#6B7280'}}>&nbsp;<span className="font-semibold" style={{color: '#2563EB'}}>{that.state.data.employees}</span> Employees took<span className="font-semibold" style={{color: '#475569'}}>&nbsp;{that.state.data.challenges_taken_till_date}</span>&nbsp;challenges in this contract year</h4>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row type="flex" justify="end" style={{paddingRight: 0,marginTop: 5}}>
                        <h4 className="top-right-delay-label" style={{marginTop: 10}}>Refreshes every <b> 1 hour </b></h4>
                      </Row>
                    </Col>
                  </Row>
                  <Card className="health-check-utilization-card" style={{marginBottom: 0}}>
                    <h3 className="font-semibold">Health Challenges</h3>
                    <Row>
                      <Col span={12}>
                        <h5 style={{color: '#6B7280',marginBottom: 60}}>The total number of challenges taken by employee is divided under categories and their health condition labels.</h5>
                      </Col>
                      <Col span={12}>
                        <Row type="flex" justify="end" className="mt-minus-35">
                          <img src={ClapsImage}/>
                        </Row>  
                      </Col>
                    </Row>
                    <Tag className="high-utilization-tag">CHALLENGES BY CATEGORIES</Tag>
                    <Row>
                      <Col span={12}>
                        {this.renderDonutChart()}
                      </Col>
                      <Col span={12} style={{borderRadius: 8,padding: 25,backgroundColor: '#F9FAFB'}}>
                        <Row>
                          <Col span={24}>
                            <a>
                              <svg height="20" width="100%" >
                                <rect x="0" y="5" width="100%" height="12" rx="6" ry="6" style={{fill: this.getColor("Default")}}/>
                                <Tooltip  title={this.renderPopoverContent((that.state.data.obesity*100/parseInt(that.state.data.challenges_taken_till_date)).toFixed(1) + '%','Challenges of Obesity: ')}>
                                  <rect x="0" y="5" id="obesity_bar" width={that.state.data.obesity*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Obesity")}} />
                                </Tooltip>
                                <Tooltip  title={this.renderPopoverContent((that.state.data.diabetes*100/parseInt(that.state.data.challenges_taken_till_date)).toFixed(1) + '%', 'Challenges of Diabetes: ')}>
                                  <rect id="diabetes_bar" x={that.state.data.obesity*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} y="5" width={that.state.data.diabetes*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Diabetes")}} />
                                </Tooltip>
                                <Tooltip  title={this.renderPopoverContent((that.state.data.blood_pressure*100/parseInt(that.state.data.challenges_taken_till_date)).toFixed(1) + '%', 'Challenges of Blood Pressure: ')}>
                                  <rect id="blood_pressure_bar" x={(parseInt(that.state.data.obesity) + parseInt(that.state.data.diabetes))*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} y="5" width={that.state.data.blood_pressure*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Blood Pressure")}} />
                                </Tooltip>
                                <Tooltip  title={this.renderPopoverContent((that.state.data.heart_health*100/parseInt(that.state.data.challenges_taken_till_date)).toFixed(1) + '%', 'Challenges of Cholestrol: ')}>
                                  <rect id="cholestrol_bar" x={(parseInt(that.state.data.obesity) + parseInt(that.state.data.diabetes) + parseInt(that.state.data.blood_pressure))*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} y="5" width={that.state.data.heart_health*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Cholestrol")}} />
                                </Tooltip>
                                <Tooltip  title={this.renderPopoverContent((that.state.data.others*100/parseInt(that.state.data.challenges_taken_till_date)).toFixed(1) + '%', 'Challenges of Others: ')}>
                                  <rect id="others_bar" x={(parseInt(that.state.data.obesity) + parseInt(that.state.data.diabetes) + parseInt(that.state.data.blood_pressure) + parseInt(that.state.data.heart_health))*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} y="5" width={that.state.data.others*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="12" rx="6" ry="6" style={{fill: this.getColor("Others")}} />
                                </Tooltip>
                                <rect x="0" y="15" id="obesity_hover_bar" width={this.state.data.obesity*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="4"  />
                                <rect x={that.state.data.obesity*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} y="15" id="diabetes_hover_bar" width={that.state.data.diabetes*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="4"  />
                                <rect x={(parseInt(that.state.data.obesity) + parseInt(that.state.data.diabetes))*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} y="15" id="blood_pressure_hover_bar" width={that.state.data.blood_pressure*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="4"  />
                                <rect x={(parseInt(that.state.data.obesity) + parseInt(that.state.data.diabetes) + parseInt(that.state.data.blood_pressure))*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} y="15" id="cholestrol_hover_bar" width={that.state.data.heart_health*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="4"  />
                                <rect x={(parseInt(that.state.data.obesity) + parseInt(that.state.data.diabetes) + parseInt(that.state.data.blood_pressure) + parseInt(that.state.data.heart_health) )*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} y="15" id="others_hover_bar" width={that.state.data.others*100/parseInt(that.state.data.challenges_taken_till_date) + '%'} height="4"  />
                              </svg>
                            </a>
                          </Col>
                          <Col span={24} style={{marginTop: 15}}>
                            <Col sm={8}>
                              <Row type="flex" justify="start">
                                <svg height="10" width="10" style={{marginTop: 10}}>
                                  <rect x="0" y="0" width="10" height="12" rx="6" ry="6" style={{fill: this.getColor("Obesity")}}/>
                                </svg>
                                <h6 className="web-login-track mt-minus-1">Obesity</h6>
                              </Row>
                              <Row type="flex" justify="start">
                                <h2 className="number-style">{that.state.data.obesity}</h2>
                              </Row>
                            </Col>
                            <Col sm={8}>
                              <Row type="flex" justify="start">
                                <svg height="10" width="10" style={{marginTop: 10}}>
                                  <rect x="0" y="0" width="10" height="12" rx="6" ry="6" style={{fill: this.getColor("Diabetes")}}/>
                                </svg>
                                <h6 className="web-login-track mt-minus-1">Diabetes</h6>
                              </Row>
                              <Row type="flex" justify="start">
                                <h2 className="number-style">{that.state.data.diabetes}</h2>
                              </Row>
                            </Col>
                            <Col sm={8}>
                              <Row type="flex" justify="start">
                                <svg height="10" width="10" style={{marginTop: 10}}>
                                  <rect x="0" y="0" width="10" height="12" rx="6" ry="6" style={{fill: this.getColor("Blood Pressure")}}/>
                                </svg>
                                <h6 className="web-login-track mt-minus-1">Blood Pressure</h6>
                              </Row>
                              <Row type="flex" justify="start">
                                <h2 className="number-style">{that.state.data.blood_pressure}</h2>
                              </Row>
                            </Col>
                          </Col>  
                          <Col span={24} style={{marginTop: 15}}>
                            <Col sm={8}>
                              <Row type="flex" justify="start">
                                <svg height="10" width="10" style={{marginTop: 10}}>
                                  <rect x="0" y="0" width="10" height="12" rx="6" ry="6" style={{fill: this.getColor("Cholestrol")}}/>
                                </svg>
                                <h6 className="web-login-track mt-minus-1">Cholestrol</h6>
                              </Row>
                              <Row type="flex" justify="start">
                                <h2 className="number-style">{that.state.data.heart_health}</h2>
                              </Row>
                            </Col>
                            <Col sm={8}>
                              <Row type="flex" justify="start">
                                <svg height="10" width="10" style={{marginTop: 10}}>
                                  <rect x="0" y="0" width="10" height="12" rx="6" ry="6" style={{fill: this.getColor("Others")}}/>
                                </svg>
                                <h6 className="web-login-track mt-minus-1">Others</h6>
                              </Row>
                              <Row type="flex" justify="start">
                                <h2 className="number-style">{that.state.data.others}</h2>
                              </Row>
                            </Col>
                            <Col sm={8}>
                              
                            </Col>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <h6 style={{color: '#9CA3AF'}} className="-mt-10">The above shows the challenges divided based on health conditions</h6>
                    </Row>
                  </Card>
                  {!!totalPointsEarned &&
                    <Row>
                      <Col span={14}>
                        <Card className="health-check-utilization-card" style={{maxHeight: 80,marginTop: 60}}>
                        <Row>
                          <Col span={12} style={{borderRight: '1px solid #CBD5E1',marginRight: 40,height: 40}}>
                            <Row type="flex" justify="start">
                              <img src={StarImage} style={{height: 40,width: 40}}/>
                              <h5 className="number-sub-title mt-minus-2 semibold" style={{marginLeft: 10}}>Total Points Earned</h5>
                            </Row>  
                            <Row type="flex" justify="start">
                              <h2 className="main-numbers mt-minus-30"  style={{color: '#475569',marginLeft: 50}}>{parseInt(that.state.data.total_points_earned).toFixed(1).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,').replace('.0','')}</h2>
                            </Row>
                          </Col> 
                          <Col span={10}>
                            <Row type="flex" justify="start">
                              <img src={MoneyImage}/>
                              <h5 className="number-sub-title mt-minus-2 semibold" style={{marginLeft: 10}}>Rupees in wallet</h5>
                            </Row>  
                            <Row type="flex" justify="start">
                              <h2 className="main-numbers mt-minus-30"  style={{color: '#475569',marginLeft: 50}}>{"\u20B9" + parseInt(that.state.data.rupees_in_wallet).toFixed(1).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,').replace('.0','')}</h2>
                            </Row>
                          </Col> 
                        </Row>
                      </Card>
                    </Col>
                  </Row> }
                  <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 60}}>
                    <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>HEALTH CHALLENGES TRENDS</h4>
                  </Row>
                  <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
                    <Row>
                      <Col span={12}>
                        <h5 style={{color: '#6B7280'}}>Trends based on the total challenges completed</h5>
                      </Col>
                      <Col span={12}>
                        <Row type="flex" justify="end">
                          <Select
                            value={dropdownValue}
                            style={{ width: 200, backgroundColor: '#fff' }} 
                            onChange={this.handleChange.bind(this)}
                            >
                            {isRunningContract && <Option value="last_30days">Last 30 Days</Option>}
                            <Option value="contract_period">Contract Period</Option>
                          </Select>
                        </Row>
                      </Col>  
                    </Row>  
                      {this.renderChartTrends()}
                  </Card>
                </div>
            }  
            </div> 
          }
      </div>   
    )
  }    
}

export default Challenges